import { ImageUploadDropzone, VideoUploadDropzone } from '@startupquickstart/frontend';
import type { ChallengeEditorSectionProps } from '../types';
import { SectionCard } from './SectionCard';

/** Standard 4:3 crop for challenge clue imagery. */
const CHALLENGE_IMAGE_ASPECT_RATIO = 4 / 3;

/** Clue image + video uploads. */
export function MediaSection({ values, errors, updateField }: ChallengeEditorSectionProps) {
  return (
    <SectionCard
      id="media"
      title="Media"
      description="Images and videos to accompany the challenge clue"
    >
      <div id="field-imageId">
        <ImageUploadDropzone
          targetAspectRatio={CHALLENGE_IMAGE_ASPECT_RATIO}
          label="Challenge Image"
          value={values.imageId || undefined}
          onChange={(mediaId) => updateField('imageId', mediaId || '')}
        />
        {errors.imageId && <p className="mt-2 text-sm text-destructive">{errors.imageId}</p>}
      </div>

      <VideoUploadDropzone
        label="Challenge Video"
        value={values.videoId || undefined}
        onChange={(mediaId) => updateField('videoId', mediaId || '')}
      />
    </SectionCard>
  );
}
